import React from 'react';
import { useAuth } from '../hooks/useAuth.js';
import videoSrc from '../assets/rideCORE_Home.mp4';
import logo from '../assets/core-kiteboarding_logo.svg';

const Login = () => {
  const { login } = useAuth();

  return (
    <>
    <video autoPlay loop muted playsInline className="backgroundVideo">
			<source src={videoSrc} type="video/mp4" />
			Your browser does not support the video tag.
		</video>
    <div className="login">
               <a href="/">
				<img src={logo} alt="Core Logo" height="160" width="160" />
			</a>
			<h1>WILLKOMMEN ZUM SHAREPOINT-ORDNER-TOOL VON CORE.</h1>
			<p>Du bist derzeit nicht eingeloggt. Bitte logge dich ein, um dieses Tool nutzen zu können.</p>
      
        <section>
        <button onClick={login} className="resource">
          <h2>EINLOGGEN</h2>
          <p>Mit dem CORE Account (Microsoft Azure AD) einloggen.</p>
        </button>
        </section>

    </div>
    </>
  );
};


export default Login;
